import { useMutation } from "@tanstack/react-query";

import { useOktaAuth } from "../hooks/useOktaAuth";
import {
  API_GATEWAY_ID_ORDER_SERVICE,
  ORDERS_SERVICE_URL,
} from "../utils/env.config";

import { RequestFactory, WithAccessToken, fetchAndParse } from "./index";

const gatewayHeaders = API_GATEWAY_ID_ORDER_SERVICE && {
  "x-apigw-api-id": API_GATEWAY_ID_ORDER_SERVICE,
};

type GenerateReconReportProps = {
  fromDate: string;
  toDate: string;
  userIdEmail: string;
};

export const generateReconReport = ({
  accessToken,
  ...data
}: WithAccessToken<GenerateReconReportProps>) => {
  const request = RequestFactory.createPostRequest(
    "/orders/report/reconciliation",
    data,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ...gatewayHeaders,
      },
    },
    ORDERS_SERVICE_URL,
  );
  return fetchAndParse(request);
};

export const useGenerateReconReport = () => {
  const { accessToken } = useOktaAuth();

  return useMutation<unknown, unknown, GenerateReconReportProps>({
    mutationFn: variables =>
      generateReconReport({
        ...variables,
        accessToken,
      }),
  });
};
